require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./case-studies-proud-to-care.json") })
        }
      }, "path---case-studies-proud-to-care");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---case-studies-proud-to-care!./.cache/json/case-studies-proud-to-care.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---case-studies-proud-to-care!./.cache/json/case-studies-proud-to-care.json
// module chunks = 231608221292675